import React, { useState, useEffect, useRef } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import ReactTable from 'Components/ReactTable/ReactTable';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';

import {
    SelectOwnBeneficiary as SELECT_BENE,
    DeleteOwnBene,
    UpdateOwnBeneficiary as UPDATE

} from 'Components/Api/CreditInstitutionSettingAPI';
import { LOGOUT } from 'ConstComponents';
import { CustomModalWithScroll } from 'Components/Modal/CustomModalWithScroll';
import {
    Container,
    Grid,
    Box,
    Paper,
    Button,
    CircularProgress,

} from '@material-ui/core';

import HOCLoader from 'Components/Loader/HOCLoader';
import { ConfirmAlert } from 'Components/Alert/ConfirmAlert';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';

const CustomContainer = HOCLoader(Container);

export const ViewOwnBeneficiary = () => {
    const classes = commonStyle();

    const formRef = useRef();
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [isError, setIsError] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [severity, setSeverity] = useState('success');
    const [currentPage, setCurrentPage] = useState(0);
    const [mainColumns, setMainColumns] = useState([]);
    const [itemList, setItemList] = useState([]);
    const [TakeCount, setTakeCount] = useState(10);
    const [SkipCount, setSkipCount] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [SearchText, setSearchText] = useState('');
    const [isDeleteAlertOpen, setIsDeleteAlertOpen] = useState(false);
    const [confirmAlertRequest, setConfirmAlertRequest] = useState({});
    const [IsUpdate, setIsUpdate] = useState(false);
    const [selectedBene, setSelectedBene] = useState(null);

    const [FormObj, setFormObj] = useState({
        accNo: '',
        name: '',
        branchName: '',
        status: '',
        transferLimit: '',
        transLimit: '',
        b_Id: ''
    });

    useEffect(() => {
        if (formRef.current && selectedBene) {
            formRef.current.setFieldValue('accNo', selectedBene.accNo || '');
            formRef.current.setFieldValue('name', selectedBene.name || '');
            formRef.current.setFieldValue('branchName', selectedBene.branchName || '');
            formRef.current.setFieldValue('status', selectedBene.status || '');
            formRef.current.setFieldValue('transferLimit', selectedBene.transferLimit || '');
            formRef.current.setFieldValue('b_Id', selectedBene.b_Id || '');
        }
    }, [selectedBene]);

    useEffect(() => {
        if (itemList.length > 0) {
            createColumns();
        }
    }, [itemList]);


    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'b_Id',
            srno: true
        });

        columns.push({
            label: 'Account Number',
            name: 'accNo'
        });

        columns.push({
            label: 'Branch Name',
            name: 'branchName',
            hide: true
        });

        columns.push({
            label: 'Transfer Limit',
            name: 'transferLimit',
            hide: true
        });

        columns.push({
            label: 'Status',
            name: 'status',
            hide: true
        });

        columns.push({
            label: 'Account Name',
            name: 'name'
        });


        columns.push({
            label: 'Edit',
            name: 'b_Id',
            edit: true,
            callback: (value) => {
                const bene = itemList.find((x) => x.b_Id === value);
                if (bene) {
                    setSelectedBene(bene);
                }
            }
        });

        columns.push({
            label: 'Delete',
            name: 'b_Id',
            delete: true,
            callback: (value) => {
                onDeleteClick(value);
            }
        });

        setMainColumns(columns);
    };

    const onDeleteClick = (item) => {
        var RequestObj = { b_Id: item };
        setIsDeleteAlertOpen(true);
        setConfirmAlertRequest(RequestObj);
    };

    const Delete = async (requestObj) => {
        setLoadingOpen(true);
        var reqObj = JSON.stringify(requestObj);
        var response = await DeleteOwnBene(reqObj);
        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();

        setIsError(true);
        setSeverity('success');
        setResponseMessage(response.data);

        if (!response.status) {
            setSeverity('error');
            return;
        }
        callSelectData(TakeCount, SkipCount, '', '', '');
    };


    useEffect(() => {
        callSelectData(TakeCount, SkipCount, '', '', '');
    }, []);

    const validationSchema = Yup.object({});

    const submithandle = async (values, { setSubmitting, resetForm }) => {

        var jsonReq = {
            TransLimit: values.transLimit,
            b_Id: values.b_Id
        };
        var requestObj = JSON.stringify(jsonReq);
        var response = await UPDATE(requestObj);
        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();

        setIsError(true);
        setSeverity('success');
        setResponseMessage(response.data);

        if (!response.status) {
            setSeverity('error');
            return;
        }
        callSelectData(TakeCount, SkipCount, '', '', '');
        formRef.current.resetForm();
        setSelectedBene(null);

    };

    const callSelectData = async (
        TakeCount,
        SkipCount,
        SearchText,
        SortColumnName,
        SortDirection
    ) => {
        let requestObj = {
            TakeCount: TakeCount,
            SkipCount: SkipCount,
        };

        var requestJSON = JSON.stringify(requestObj);
        setIsError(false);
        setLoadingOpen(true);
        const response = await SELECT_BENE(requestJSON);
        setLoadingOpen(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);

            return;
        }

        var data = JSON.parse(response.data);

        if (SkipCount <= 0) {
            setTotalCount(data.Count);
        }
        setItemList(data.Beneficiary); 
        createColumns();
    };

    function downloadFile(URL, Title) {
        let a = document.createElement('a');
        a.href = URL;
        a.setAttribute('download', Title);
        a.setAttribute('target', '_blank');
        a.click();
    }

    const refreshForm = () => {
        if (!formRef.current) return;

        formRef.current.handleSubmit();
    };
    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                validationSchema={validationSchema}
                onSubmit={submithandle}
                initialValues={FormObj}
                render={({ values, setFieldValue, handleSubmit }) => {
                    return (
                        <Form>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Paper className={classes.PaperStyle}>
                                    <Grid container spacing={2}>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialTextField
                                                label="Account Number"
                                                name="accNo"
                                                type="text"
                                                placeholder="Account Number"
                                                readOnly={true}
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialTextField
                                                label="Branch Name"
                                                name="branchName"
                                                type="text"
                                                placeholder="Branch Name"
                                                readOnly={true}
                                            />
                                        </Grid>


                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialTextField
                                                label="Account Holder Name"
                                                name="name"
                                                type="text"
                                                placeholder="Name"
                                                readOnly={true}
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialTextField
                                                label="Status"
                                                name="status"
                                                type="text"
                                                placeholder="Status"
                                                readOnly={true}
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialTextField
                                                label="Transfer Limit"
                                                name="transferLimit"
                                                type="text"
                                                placeholder="Transfer Limit"
                                                readOnly={true}
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={3}
                                            lg={3}
                                        >
                                            <MaterialTextField
                                                label="Transfer Limit"
                                                name="transLimit"
                                                type="text"
                                                placeholder="Transfer Limit"
                                            />
                                        </Grid>

                                    </Grid>
                                    <Grid className={classes.footerGrid}>
                                        <Box className={classes.flexReverse}>
                                            <div className={classes.SubmitWrapper}>
                                                <Button
                                                    type="submit"
                                                    title="Update"
                                                    className={
                                                        classes.CustomPrimaryButtonStyle
                                                    }
                                                    disabled={loadingOpen}
                                                >
                                                    Submit
                                                </Button>
                                                {loadingOpen && (
                                                    <CircularProgress
                                                        size={24}
                                                        className={
                                                            classes.buttonProgress
                                                        }
                                                    />
                                                )}
                                            </div>

                                        </Box>
                                    </Grid>
                                </Paper>
                                <div
                                    className={classes.SubmitWrapper}
                                ></div>
                            </Grid>
                        </Form>
                    );
                }}
            />

            <h2 className={classes.PaperHead_h2}>Beneficiary Report</h2>

            <ReactTable
                data={itemList}
                columns={mainColumns}
                count={totalCount}
                rowsPerPage={TakeCount}
                serverSide={true}
                getCallback={({ currentPage, RowsPerPage }) => {
                    setCurrentPage(currentPage);
                    setTakeCount(RowsPerPage);
                    setSkipCount(RowsPerPage * currentPage);
                    callSelectData(
                        RowsPerPage,
                        RowsPerPage * currentPage,
                        '',
                        '',
                        ''
                    );
                }}
                getSearchCallback={({ SearchText }) => {
                    callSelectData(TakeCount, currentPage, SearchText, '', '');
                }}
                getSortCallback={({ column, direction }) => {
                    callSelectData(
                        TakeCount,
                        currentPage,
                        SearchText,
                        column,
                        direction
                    );
                }}
            />

            {isDeleteAlertOpen ? (
                <ConfirmAlert
                    isOpen={isDeleteAlertOpen}
                    title="Delete Confirmation"
                    message="Are you sure to delete this beneficiary."
                    request={confirmAlertRequest}
                    positiveButtonClick={(request) => {
                        setIsDeleteAlertOpen(false);
                        Delete(request);
                    }}
                    negativeButtonClick={() => {
                        setIsDeleteAlertOpen(false);
                    }}
                />
            ) : null}
        </CustomContainer>
    );
};
